export default __webpack_public_path__ + "images/096e83f6cfb21ca01d664691a59a4cd7-diy.webp";